import React from "react";
import "../sass/main.scss";
import { Button, Card, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SignUp = () => {
  const navigate = useNavigate();
  return (
    <div className="fluid-container background">
      <div className="main">
        <Card className="card">
          <div className="column-center p-2">
            <h4>Open an account</h4>
            <label className="label">
              Save hours of finance work every week
            </label>
          </div>
          <div className="row pt-3">
            <div className="col-sm-6 p-2">
              <TextField
                id="filled-basic"
                label="first name"
                variant="filled"
                InputProps={{ disableUnderline: true }}
                className="width-textfield"
              />
            </div>
            <div className="col-sm-6 p-2">
              <TextField
                id="filled-basic"
                label="last name"
                variant="filled"
                InputProps={{ disableUnderline: true }}
                className="width-textfield"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 p-2">
              <TextField
                id="filled-basic"
                label="What's your work email?"
                variant="filled"
                InputProps={{ disableUnderline: true }}
                className="width-textfield"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 p-2">
              <TextField
                type="password"
                id="filled-basic"
                label="Choose Password(min 12 characters)"
                variant="filled"
                InputProps={{ disableUnderline: true }}
                className="width-textfield"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 p-2">
              <TextField
                type="password"
                id="filled-basic"
                label="Repeat Password"
                variant="filled"
                InputProps={{ disableUnderline: true }}
                className="width-textfield"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 p-2">
              <Button className="btn-main width-textfield">Open Account</Button>
            </div>
          </div>
          <div className="column-center p-2">
            <label className="label">
              Already have an account?{" "}
              <span className="text-underline" onClick={() => navigate("/")}>
                Sign in
              </span>
            </label>
            <label className="label">
              Signing up for vault means you agree to the Privacy policy and
              Terms of service
            </label>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default SignUp;
